import * as React from 'react';
import Button from '../Components/Button';
import MoneyInput from '../Components/MoneyInput';
import Radio from '../Components/Radio';
import Row from '../Components/Row';
import Product from '../Models/Product';

require('../css/amount-selection.css');

interface Styles {
  backgroundColor?: string;
  textColor?: string;
  selectedAmount?: string;
  notSelectedAmount?: string;
  button?: string;
  amount?: string;
  textboxTextColor?: string;
  donationAmountHeadingColor?: string;
  enterDonationColor?: string;
  selectedPackage?: string;
  notSelectedPackage?: string;
  packageRadioButton?: string;

}

interface Props {
  donationAmounts: number[];
  donationAmountsMonthly: number[];
  amount: number;
  styles?: Styles;
  product: Product;
  titleText: string;
  disclaimerText: string;
  Header: string;
  priceSymbol?: string;
  useIBAN?: boolean;
  bankPaymentRadioButtonLabel?: string;
  bankPaymentRadioButtonLabel2?: string;

  donationSelected(amount: number, paymentMethod: 'creditcard' | 'bankaccount' | 'directdebit', paymentSelection: 'monthly' | 'single'): void;
}

interface DonationAmount {
  amount: number;
  isSelected: boolean;
}

interface State {
  donationAmounts: DonationAmount[];
  otherDonationAmount: DonationAmount;

  amount: number;
  immediateAmount: number;
  paymentMethod: 'creditcard' | 'bankaccount' | 'directdebit';
  paymentSelection: 'monthly' | 'single';

}

export default class AmountSelectionForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    const styles = this.props.styles || {};

    this.state = {

      donationAmounts: props.product.paymentType[0].toLowerCase() as 'monthly' | 'single' === 'monthly' ? 
      this.props.donationAmountsMonthly.map((donation) => {
        return {
          amount: donation,
          isSelected: props.amount === donation,
        };
      }) : this.props.donationAmounts.map((donation) => {
        return {
          amount: donation,
          isSelected: props.amount === donation,
        };
      }),

      otherDonationAmount: {
        amount: props.amount,
        isSelected:  props.product.paymentType[0].toLowerCase() as 'monthly' | 'single' === 'monthly' ? 
        props.donationAmountsMonthly.every(donationAmount => donationAmount !== props.amount) : props.donationAmounts.every(donationAmount => donationAmount !== props.amount),
      },

      amount: props.amount,
      paymentMethod: 'creditcard',
      paymentSelection: props.product.paymentType[0].toLowerCase() as 'monthly' | 'single',
      immediateAmount: props.amount
    };
    
    this.updatePriceList(this.state.paymentSelection);
  }

  submitAndValidateDonationDetails = () => {

    if (this.state.amount > 0) {

      this.props.donationSelected(
        this.state.amount,
        this.state.paymentMethod,
        this.state.paymentSelection);
    }
  }

  setPaymentMethod() {
    if (this.props.useIBAN) {
      this.setState({ paymentMethod: 'bankaccount' });
    } else {
      this.setState({ paymentMethod: 'directdebit' });
    }
  }

  updatePriceList(paymentSelection: string) {
    
    if (paymentSelection === 'monthly') {
     
      this.setState({
        donationAmounts: this.props.donationAmountsMonthly.map((donation) => {
          return {
            amount: donation,
            isSelected: this.state.amount === donation,
          };
        })
      });
      this.setState({
        otherDonationAmount: {
          amount: this.state.amount,
          isSelected: this.props.donationAmountsMonthly.every(donationAmount => donationAmount !== this.state.amount),
        }
      });
    } else if (paymentSelection === 'single') {
      this.setState({
        donationAmounts: this.props.donationAmounts.map((donation) => {
          return {
            amount: donation,
            isSelected: this.state.amount === donation,
          };
        })
      });
      this.setState({
        otherDonationAmount: {
          amount: this.state.amount,
          isSelected: this.props.donationAmounts.every(donationAmount => donationAmount !== this.state.amount),
        }
      });
    }
  }

  render() {
    let pSymbol = '';

    if (this.props.priceSymbol) {
      pSymbol = this.props.priceSymbol;
    }

    const styles = this.props.styles || {};

    let mainDivClass = 'amount-block';

    if (styles.backgroundColor) {
      mainDivClass += ' ' + styles.backgroundColor;
    }

    let headingClass = 'textCenter';

    if (styles.textColor) {
      headingClass += ' ' + styles.textColor;
    }

    if (styles.donationAmountHeadingColor) {
      headingClass += ' ' + styles.donationAmountHeadingColor;
    }

    let textClass = 'textCenter amountTextDescription';

    if (styles.textColor) {
      textClass += ' ' + styles.textColor;
    }

    let packageRadioButtonClass = '';

    if (styles.packageRadioButton) {
      packageRadioButtonClass += ' ' + styles.packageRadioButton;
    }

    let enetrDonationClass = '';

    if (styles.enterDonationColor) {
      enetrDonationClass = styles.enterDonationColor;
    }

    let amountDivClass = 'amountSelection-block';

    if (styles.amount) {
      amountDivClass += ' ' + styles.amount;
    }

    let textBoxClass = 'whiteBackground textboxStyle ';
    let textboxSymbolClass = 'symbolStyle';
    let textboxDivClass = 'setsymboldisplay';

    let overAllDivClass = 'blueBackGround';

    if (styles.textboxTextColor) {
      textBoxClass += ' ' + styles.textboxTextColor;
      textboxSymbolClass += ' ' + styles.textboxTextColor;
    }

    let blockFontClass = 'setblockfontstyle';
    let blockIconClass = 'setblockiconstyle';

    let titleDivClass;

    return (
      <Row className={mainDivClass + ' sidePane'} >
        <div className="col s12 m12 lg12 xl12" >

          <div className={overAllDivClass}>
            {this.props.Header && <div dangerouslySetInnerHTML={{ __html: this.props.Header }} />}

            <Row>
              <div className="col s12 m12 lg12 xl12">
                <h3 className={headingClass}><b>{this.props.titleText}</b></h3>
              </div>
            </Row>

            <Row>
              <div className="col s12 m12 lg12 xl12">
                <p className={textClass}>{this.props.disclaimerText}</p>
              </div>
            </Row>
          </div>
          <Row className="marginCenter">
            <Row className="marginBottom0">

              <div className="col s1 m2 lg2 xl2 emptyDiv">
                &nbsp;
              </div>

              <div className="col s10 m8 lg7 xl7 sidePane">
                <Row  className="sidePane_Row">
                  <div className="col s12 m12 lg12 xl12">
                    <Row  className="sidePane_Row">
                      {this.props.product.paymentType.indexOf('Monthly') !== -1
                        && this.props.product.paymentType.indexOf('Single') !== -1 && (
                          <>
                            <div className="packageSelectionBtn">
                              <div
                                className={`linkCursorStyle ${this.state.paymentSelection === 'monthly'
                                    ? styles.selectedPackage
                                    : styles.notSelectedPackage
                                  }`}
                                onClick={() => {
                                  this.setState({ paymentSelection: 'monthly' });
                                  this.updatePriceList('monthly');
                                }}
                              >
                                <h4>
                                  <b>MONTHLY</b>
                                </h4>
                              </div>
                            </div>

                            <div className="packageSelectionBtn">
                              <div
                                className={`linkCursorStyle ${this.state.paymentSelection === 'single'
                                    ? styles.selectedPackage
                                    : styles.notSelectedPackage
                                  }`}
                                onClick={() => {
                                  this.setState({ paymentSelection: 'single' });
                                  this.updatePriceList('single');
                                }}
                              >
                                <h4>
                                  <b>SINGLE</b>
                                </h4>
                              </div>
                            </div>
                          </>
                        )}
                      {this.props.product.paymentType.indexOf('Monthly') === -1
                        && this.props.product.paymentType.indexOf('Single') !== -1 && (
                          <></>
                          
                        )}

                      {this.props.product.paymentType.length === 0 && (
                        <></>                        
                      )}
                    </Row>
                  </div>

                </Row>
              </div>

              <div className="col s1 m2 lg3 xl3 emptyDiv">
                &nbsp;
              </div> 
            </Row>

            <Row className="marginBottom0">
              <div className="col s1 m2 lg2 xl2 emptyDiv">
                &nbsp;
              </div>

              <div className="col s10 m8 lg7 xl7 sidePane">
                <Row className={amountDivClass + ' sidePane_AmountSelection'}>

                  {this.state.donationAmounts.map((donationAmount, index) => (
                    <div className="col s6 m3 lg3 xl3 ">
                      <div
                        className={`textCenter linkCursorStyle setblockWidth ${donationAmount.isSelected ? styles.selectedAmount : styles.notSelectedAmount}`}
                        onClick={() => {

                          this.setState(prevState => ({
                            ...prevState,
                            amount: donationAmount.amount,
                            donationAmounts: prevState.donationAmounts.map((donation, i) => {
                              return {
                                ...donation, isSelected: i === index,
                              };
                            }),
                            otherDonationAmount: {
                              ...prevState.otherDonationAmount,
                              isSelected: false
                            }
                          }));
                        }}
                      >
                        <h4 className={blockFontClass}><i className={`material-icons ${blockIconClass}`}>{pSymbol}</i> {donationAmount.amount / 100}</h4>
                      </div>
                    </div>
                  ))}

                  <div className="col s6 m3 lg3 xl3 ">
                    <div
                      className={`textCenter linkCursorStyle setblockWidth ${this.state.otherDonationAmount.isSelected ? styles.selectedAmount : styles.notSelectedAmount}`}
                      onClick={() => {

                        this.setState(prevState => ({
                          ...prevState,
                          donationAmounts: prevState.donationAmounts.map((donation, i) => {
                            return {
                              ...donation,
                              isSelected: false,
                            };
                          }),
                          otherDonationAmount: {
                            ...prevState.otherDonationAmount,
                            isSelected: true
                          }
                        }));
                      }}
                    >
                      <h4 className={`pt5 ${blockFontClass}`}>Other</h4>
                    </div>
                  </div>

                </Row>
              </div>
              <div className="col s1 m2 lg3 xl3 emptyDiv">
                &nbsp;
              </div>
            </Row>

            <Row className="marginBottom0" style={this.state.otherDonationAmount.isSelected ? { display: 'block' } : { display: 'none' }}>
              <div className="col s1 m2 lg2 xl2 emptyDiv">
                &nbsp;
              </div>
              <div className="col s10 m8 lg7 xl7 sidePane">
                <span>
                  <Row className={`whiteBackground ${enetrDonationClass}`} >
                    <div className="col s12 m12 lg12 xl12 ">
                      <MoneyInput
                        id="donation-value"
                        value={this.state.amount}
                        label=""
                        inputProps={{ disabled: false }}
                        onChange={enteredAmount => this.setState({ amount: enteredAmount })}
                        textInputInputClassName={textBoxClass}
                        icon={pSymbol}
                        textInputIconClassName={textboxSymbolClass}
                        textInputDivClassName={textboxDivClass}
                        onChangeImmediate={textAmount => this.setState({ immediateAmount: textAmount === '' ? 0 : parseFloat(textAmount) })}
                      />
                    </div>
                  </Row>
                </span>

              </div>
              <div className="col s1 m2 lg3 xl3 emptyDiv">
                &nbsp;
              </div>
            </Row>
          </Row>
          <Row
            className="marginBottom0"
            style={this.state.paymentSelection === 'monthly' ? { display: 'block' } : { display: 'none' }}
          >
            <div className="col m2 lg2 xl2 emptyDiv">
              &nbsp;
            </div>
            <div className="col s12 m8 lg8 xl8 sidePane ">
              <Row>
                <div className="marginLeft8 brownColorClass">How would you like to make your donation?
                </div>
              </Row>
              <Row>
                <div className="col s12 m6 lg6 xl6 ">
                  <div>
                    <Radio
                      label={this.props.bankPaymentRadioButtonLabel2}
                      id="from-credit-card"
                      group="package-selection"
                      labelClassName={packageRadioButtonClass}
                      onChange={() => this.setState({ paymentMethod: 'creditcard' })}
                      defaultChecked={true}
                    />
                  </div>
                </div>
                <div className="col s12 m6 lg6 xl6 ">
                  <div>
                    <Radio
                      label={this.props.bankPaymentRadioButtonLabel}
                      id="from-bank-account"
                      group="package-selection"
                      labelClassName={packageRadioButtonClass}
                      onChange={() => this.setPaymentMethod()}
                      defaultChecked={false}
                    />
                  </div>
                </div>
              </Row>
            </div>
            <div className="col m2 lg2 xl2 emptyDiv">
              &nbsp;
            </div>
          </Row>
        </div>

        <Button
          disabled={this.state.amount <= 0 && this.state.immediateAmount <= 0}
          className={styles.button}
          onClick={this.submitAndValidateDonationDetails}
        >
          Next
        </Button>

      </Row >
    );
  }
}



// WEBPACK FOOTER //
// ./src/AmountSelection/AmountSelectionForm.tsx